import React, { useEffect, useState } from "react";
import axios from "axios";
import Topbar from '../components/topbar'; 
import Sidebar from '../components/sidebar'; 
import Footer from '../components/footer'; 
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API_URL = `${BASE_URL}admin/getdata/get_roomamenities.php`; // change path
const IMG_URL = `${BASE_URL}admin/assets/uploads/`;

const RoomAmenities = () => {
  const [amenities, setAmenities] = useState([]);
  const [name, setName] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [editing, setEditing] = useState(null);
  const [message, setMessage] = useState("");

  const fetchAmenities = async () => {
    const res = await axios.get(API_URL);
    setAmenities(res.data);
  };

  useEffect(() => {
    fetchAmenities();
  }, []);

  const uploadImage = async () => {
    const formData = new FormData();
    formData.append("image", imageFile);

    const res = await axios.post(`${API_URL}?action=upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data.file;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let imageName = editing?.image || "";

    if (imageFile) {
      imageName = await uploadImage();
    }

    if (editing) {
      await axios.post(`${API_URL}?action=update`, {
        id: editing.id,
        name,
        image: imageName,
      });
      setMessage("Amenities Updated successfully");
    } else {
      await axios.post(`${API_URL}?action=create`, {
        name,
        image: imageName,
      });
      setMessage("Amenities added successfully");
    }

    setName("");
    setImageFile(null);
    setEditing(null);
    fetchAmenities();
  };

  const handleEdit = (item) => {
    setEditing(item);
    setName(item.name);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete?")) {
      await axios.post(`${API_URL}?action=delete`, { id });
      fetchAmenities();
      setMessage("Amenities Deleted successfully");
    }
  };

  return (
     <div class="header-light sidebar-dark sidebar-expand">
        <Topbar />
        <div class="content-wrapper">
        <Sidebar />  
         <main class="main-wrapper clearfix">
                  <div class="widget-list">

    
      <div className="container mt-4">
      <h3>Amenities Details</h3>
        {message && <div className="alert alert-info py-2">{message}</div>}
      <div className="card mt-3">
        <div className="card-header">Add Amenities Details</div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <label>Image</label>
            <input type="file" className="form-control mb-3" onChange={(e) => setImageFile(e.target.files[0])} />
            <label>Amenities Name</label>
            <input type="text" className="form-control mb-3" placeholder="Amenities Name" value={name} onChange={(e) => setName(e.target.value)} />
            <button className="btn btn-primary"> {editing ? "Update" : "Submit"} </button>
          </form>
        </div>
      </div>

      <div className="card mt-4">
        <div className="card-header">View Amenities</div>
        <table className="table table-bordered mb-0">
          <thead className="table-light">
            <tr>
              <th>Sl. No.</th>
              <th>Image</th>
              <th>Amenities Name</th>
              <th width="120">Action</th>
            </tr>
          </thead>
          <tbody>
            {amenities.length > 0 ? (
              amenities.map((a, i) => (
                <tr key={a.id}>
                  <td>{i + 1}</td>
                  <td>
                    <img src={IMG_URL + a.image} alt="" width="40" height="40"/>
                  </td>
                  <td>{a.name}</td>
                  <td>
                    <button className="btn btn-sm btn-secondary me-2" onClick={() => handleEdit(a)}>✏️</button> &nbsp; &nbsp;
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(a.id)}>🗑 </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  No Amenities Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
    </div>
    
    </main>
     <Footer />
    </div>
    </div>
  );
};

export default RoomAmenities;
